import styled, { css } from 'styled-components';

import Button from '@components/Button';

export const ResponsiveBox = styled.div`
  width: 100%;
  height: 126px;
  padding: 15px 15px 15px 20px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ResponsiveSearchBoxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SearchBoxDateWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AirportWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SwitchAirportIconWrapper = styled.div`
  margin: 0px 10px;
`;

export const ResponsiveSearchBoxItem = styled.div`
  display: flex;
  align-items: center;
`;

export const ResponsiveSearchBoxLabel = styled.span`
  margin: 0 0 0 5px;
  font-size: 14px;
  font-weight: bold;
  line-height: normal;
  color: ${({ theme }) => theme.palette.matterHorn};
`;

export const ResponsiveSearchBoxLabelBig = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.coral};
`;

export const ResponsiveSearchBoxEdit = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  line-height: normal;
`;

export const ResponsiveSearchBoxEditLabel = styled.span`
  margin: 1px 5px 1px 0;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.black11};
`;

export const SearchBoxSpacer = styled.div``;

export const LocationAnimationErrorBox = styled.div<{
  hasError: boolean;
  hasAnimationOnError?: boolean;
  borderRadius?: string;
}>`
  flex: 1;
  height: fit-content;
  ${({ hasError, hasAnimationOnError = true, borderRadius = '4px' }) =>
    hasError &&
    css`
      border-radius: ${borderRadius};
      border: ${({ theme }) => `1px solid ${theme.palette.coral}`};
      animation: ${() =>
        hasAnimationOnError &&
        'shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97)'};
    `}

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;

export const SearchButton = styled(Button)<{
  minHeight?: number;
}>`
  height: auto !important;
  font-size: 14px !important;
  font-weight: bold;
  height: ${({ minHeight }) =>
    minHeight ? `${minHeight}px` : '78px'} !important;
`;
